import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import filter from 'lodash/filter';
import orderBy from 'lodash/orderBy';
import AnchorLink from 'react-anchor-link-smooth-scroll';

import { getNodes, isEmpty } from '../utils';
import { colors } from '../styles/theme';
import { HiddenText } from './elements';

import LLLLogo from '../images/lll.svg';
import FooterLove from '../images/footer-love.svg';

export default () => (
  <StaticQuery
    query={graphql`
      query FooterQuery {
        friends: allWordpressWpFriends {
          edges {
            node {
              id
              title
              menu_order
              categories: friend_categories
              acf {
                homepage
                facebook
                instagram
                twitter
                youtube_channel
                video
              }
              featured_media {
                source_url
              }
            }
          }
        }
        categories: allWordpressWpFriendCategories(filter: { name: { ne: "Uncategorized" } }) {
          edges {
            node {
              id
              wordpress_id
              name
              count
            }
          }
        }
      }
    `}
    render={data => <Footer data={data} />}
  />
);

const Footer = ({ data }) => {
  const categories = orderBy(getNodes(data.categories), 'count', 'desc').map((cat) => {
    const friends = filter(
      orderBy(getNodes(data.friends), 'menu_order'),
      friend => friend.categories[0] === cat.wordpress_id
    );

    return {
      ...cat,
      friends,
    };
  });

  return (
    <footer
      css={{
        position: 'relative',
        overflow: 'hidden',
        marginTop: '3rem',
        padding: '2rem 0',
        borderTop: `1px solid ${colors.pr.gray200}`,
        // background: colors.pr.gray800,
      }}
    >
      <section className="section" css={{ paddingTop: '2rem', paddingBottom: 0 }}>
        <div className="container" css={{ lineHeight: 1 }}>
          <div
            css={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              // fontSize: 12,
              fontWeight: 500,
              // textTransform: 'uppercase',
            }}
          >
            <AnchorLink
              href="#top"
              css={{
                marginRight: 16,
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                '&:hover .btt': {
                  transform: 'translateX(0)',
                  opacity: 1,
                },
              }}
            >
              <LLLLogo css={{ height: '1.75rem', marginRight: 16 }} />
              <span
                css={{
                  textTransform: 'uppercase',
                  fontSize: 14,
                  fontWeight: 500,
                  letterSpacing: 2,
                  opacity: 0,
                  transform: 'translateX(-10px)',
                  transition: 'all 0.2s ease',
                }}
                className="btt"
              >
                Back To Top
              </span>
            </AnchorLink>
            <div
              css={{
                a: {
                  display: 'inline-flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '2.5em',
                  height: '2.5em',
                  borderRadius: '2rem',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    background: colors.pr.gray200,
                  },
                },
              }}
            >
              <a
                href="https://www.facebook.com/erwanmuhibbain19/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-facebook-f" />
                <HiddenText>Facebook</HiddenText>
              </a>
              <a
                href="https://www.instagram.com/erwanmuhibbain/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-instagram" />
                <HiddenText>Instagram</HiddenText>
              </a>
              <a
                href="https://www.youtube.com/user/erwant76"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-youtube" />
                <HiddenText>YouTube</HiddenText>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="section">
        <div className="container">
          <div className="columns">
            {categories.map(cat => (
              <div className="column" key={cat.id}>
                <h3
                  css={{
                    fontSize: 16,
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    marginBottom: '1rem',
                  }}
                >
                  {cat.name}
                  {cat.count > 1 && 's'}
                </h3>

                <ul
                  css={{
                    fontSize: 15,
                  }}
                >
                  {cat.friends.map(friend => (
                    <Friend friend={friend} key={friend.id} />
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="section" css={{ paddingTop: 0 }}>
        <div className="container" css={{ lineHeight: 1 }}>
          <div
            css={{
              fontSize: 14,
              fontWeight: 500,
              letterSpacing: 2,
              // textTransform: 'uppercase',
              color: colors.pr.gray500,
            }}
          >
            <div>Copyright &copy; {new Date().getFullYear()} Learn Love Live.</div>
            <div
              css={{
                fontSize: '0.8em',
                marginTop: 4,
                color: colors.pr.gray400,
              }}
            >
              Handcrafted with <i className="fas fa-heart" css={{ color: colors.primary }} /> by{' '}
              <a href="https://wansaleh.com" target="_blank" rel="noopener noreferrer">
                Wan Saleh.
              </a>
            </div>
          </div>
        </div>
      </section>

      <FooterLove
        css={{
          width: 500,
          transform: 'rotate(-30deg)',
          position: 'absolute',
          bottom: -270,
          right: -80,
          zIndex: -1,
        }}
      />
    </footer>
  );
};

const Friend = ({ friend }) => (
  <li
    css={{
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      lineHeight: 1.6,
      fontSize: 14,
    }}
  >
    {/* <div
      css={{
        position: 'absolute',
        left: -14,
        top: 'calc(50% - 2.5px)',
        width: 5,
        height: 5,
        // borderRadius: '50%',
        background: friend.acf.bg_color
      }}
    /> */}

    <div css={{ marginRight: 5 }}>{friend.title}</div>

    {!(friend.featured_media && friend.featured_media.source_url)
      && isEmpty(friend.acf.homepage)
      && isEmpty(friend.acf.facebook)
      && isEmpty(friend.acf.instagram)
      && isEmpty(friend.acf.twitter)
      && isEmpty(friend.acf.youtube_channel) && (
        <div
          css={{
            textTransform: 'uppercase',
            fontSize: '0.6em',
            fontWeight: 800,
            border: '1px solid',
            color: colors.pr.gray400,
            borderRadius: 4,
            lineHeight: 1.4,
            padding: '0 0.5em',
          }}
        >
          Soon
        </div>
    )}

    <SocLinks>
      {!isEmpty(friend.acf.homepage) && (
        <a href={friend.acf.homepage} target="_blank" rel="noopener noreferrer">
          <i className="fal fa-home" />
          <HiddenText>Home</HiddenText>
        </a>
      )}
      {!isEmpty(friend.acf.facebook) && (
        <a href={friend.acf.facebook} target="_blank" rel="noopener noreferrer">
          <i className="fab fa-facebook-f" />
          <HiddenText>Facebook</HiddenText>
        </a>
      )}
      {!isEmpty(friend.acf.instagram) && (
        <a href={friend.acf.instagram} target="_blank" rel="noopener noreferrer">
          <i className="fab fa-instagram" />
          <HiddenText>Instagram</HiddenText>
        </a>
      )}
      {!isEmpty(friend.acf.twitter) && (
        <a href={friend.acf.twitter} target="_blank" rel="noopener noreferrer">
          <i className="fab fa-twitter" />
          <HiddenText>Twitter</HiddenText>
        </a>
      )}
      {!isEmpty(friend.acf.youtube_channel) && (
        <a href={friend.acf.youtube_channel} target="_blank" rel="noopener noreferrer">
          <i className="fab fa-youtube" />
          <HiddenText>YouTube</HiddenText>
        </a>
      )}
    </SocLinks>
  </li>
);

const SocLinks = styled.div`
  display: flex;
  a {
    padding: 0 4px;
    font-size: 0.8em;
    color: ${colors.pr.gray500};

    &:hover {
      color: ${colors.primary};
    }
  }
`;
